export default __webpack_public_path__ + "static/media/overviewImage.46633b5d.jpg";